import styled, { css } from 'styled-components';

const indentValue = 25;

export const ActionGroupButton = styled.button`
  ${({ indentLevel, theme }) => css`
    background: #fff;
    border-radius: 8px;
    border: 1px solid ${theme.color.secondary};
    background-color: ${theme.color.secondary};
    display: grid;
    grid-template-columns: 1fr 2rem;
    grid-column-gap: 0.6rem;
    justify-content: space-between;
    align-items: center;
    color: #f9f9f9;
    padding: 0.6rem 1rem;
    margin-bottom: 10px;
    margin-left: auto;
    font-size: 1rem;
    text-align: left;
    cursor: pointer;
    width: 100%;
    max-width: ${indentLevel
      ? `calc(100% - (${indentValue}px * ${indentLevel}))`
      : '100%'};

    :focus-visible {
      border-color: #fff;
      box-shadow: 0 0 0 2px ${theme.color.secondary};
    }
    :disabled {
      filter: grayscale(1);
      cursor: auto;
      pointer-events: none;
    }
  `}
`;
ActionGroupButton.displayName = 'ActionGroupButton';

export const ActionGroupLabelCounterContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
`;
ActionGroupLabelCounterContainer.displayName =
  'ActionGroupLabelCounterContainer';

export const ActionGroupLabel = styled.p`
  line-height: normal;
  word-break: break-word;
`;
ActionGroupLabel.displayName = 'ActionGroupLabel';

export const ActionGroupCounter = styled.div`
  background-color: #46beaf;
  color: #ffffff;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8rem;
  padding: 0.2rem 0.5rem;
`;
ActionGroupCounter.displayName = 'ActionGroupCounter';

export const ActionGroupIconContainer = styled.div`
  transform: ${(props) => (props.active ? 'rotate(270deg)' : 'rotate(90deg)')};
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;
ActionGroupIconContainer.displayName = 'ActionGroupIconContainer';

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-start;
  align-items: flex-end;
`;
ActionsContainer.displayName = 'ActionsContainer';
